import type { DevelopmentContentDuration, FilterState, DevelopmentContentLastUpdated } from '../types';

const { APP_CONSTANTS } = window;

export const GO1_API_ROOT_URL = 'go1';
export const LEARNER_HOME = '/guides';
// Search Page
export const SEARCH_MAX_CHAR_COUNT = 255;
export const SEARCH_MAX_PAGE_SIZE = 24;

// Not doing internationalization for duration options as other filter options come in english only (from go1 directly).
// So keeping this in english only to keep it inline with the other filters' options
export const DURATION_FILTER_ID_TO_NAME: { [key in DevelopmentContentDuration]: string } = {
  LESS_THAN_15_MINS: '< 15 mins',
  BETWEEN_15_TO_30_MINS: '15 to 30 mins',
  BETWEEN_31_TO_60_MINS: '31 to 60 mins',
  MORE_THAN_60_MINS: '> 60 mins',
};

export const LAST_UPDATED_FILTER_ID_TO_NAME: { [key in DevelopmentContentLastUpdated]: string } = {
  LAST_30_DAYS: 'Last 30 days',
  LAST_90_DAYS: 'Last 90 days',
  LAST_180_DAYS: 'Last 6 months',
  LAST_1_YEAR: 'Last year',
  ALL_TIME: 'All time',
};

// Params for featured query that is used on multiple pages
export const FEATURED_CONTENT_QUERY_PARAMS: Partial<FilterState> = {
  sort: APP_CONSTANTS.GO1_SEARCH_SORT_OPTION.RELEVANCE,
  language: ['en'],
  topic: ['General Personal Development'],
  limit: 20,
  page: 0,
  lastUpdated: APP_CONSTANTS.GO1_SEARCH_LAST_UPDATED_OPTION.LAST_180_DAYS,
};

export const MIXPANEL_EVENT_PAGINATION_PREV = 'go1_learner_view_pagination_prev';
export const MIXPANEL_EVENT_PAGINATION_NEXT = 'go1_learner_view_pagination_next';
